import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiorComponent } from './simple-icons-dior.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiorComponent ],
    exports:      [ SimpleIconsDiorComponent ],
    bootstrap:    []
})
export class SimpleIconsDiorModule {}
